import { useSdk } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation } from "@tanstack/react-query";

const useSetIsOnboardingDone = () => {
    const { userManager } = useSdk();

    const setOnboardingIsDoneFn = async (isOnboardingDone: boolean) => {
        try {
            await userManager.setIsOnboardingDone(isOnboardingDone);
        } catch (error) {
            console.error(error);
        }
    };

    const setOnboardingIsDone = useMutation({
        mutationFn: setOnboardingIsDoneFn,
    });

    return setOnboardingIsDone;
};

export default useSetIsOnboardingDone;
